import DataDisplayRowI from "../DataDisplayRowI";
import getOrderRow from "../DataDisplayRow/OrderRow";
import DataDisplayTable from "../DataDisplayTable";

class OrderTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getOrderRow()
    }
}

let orderTable: OrderTable | null = null;

export default function getOrderTable(): OrderTable {
    if (orderTable === null)
        orderTable = new OrderTable()
    return orderTable
}